Monet.Format = Monet.Format || {};
Monet.Format.SWITCH = (function () {

  function SWITCH(value, dataContext, entity, field){
    Monet.Format.CHECKBOX.apply(this, arguments);
  }

  return SWITCH;

}());